<div class="alert-box" *ngIf="isAlertVisible" pplFocusTrap (escape)="closeAlert()">
    <div class="overlay"></div>
    <div class="content" role="alertdialog" aria-modal="true" aria-labelledby="alertTitle"
        aria-describedby="alertMessage" tabindex="-1" #dialogContainer>
        <div class="header">
            <div class="icon" style="color:green; font-size: 2.286rem;">
                <div *ngIf="success">
                    <i class="fa fa-check-circle"></i>
                </div>
                <div *ngIf="!success" style="color:red; font-size: 2.286rem;">
                    <i class="fa fa-times-circle"></i>
                </div>


            </div>
            <div class="title"  id="alertTitle">
                {{ title }}
            </div>
        </div>
        <div class="body">
            <div class="body-content" id="alertMessage" #alertMessageContainer>
                {{ message }}
            </div>
        </div>
        <div class="action-footer">
            <ppl-button #gotItButton label="Got it!" tabindex="0" icon="fa fa-check-circle" [customClass]="'primary-button large'"
                [iconPosition]="'left'" (click)="closeAlert()"></ppl-button>
        </div>
    </div>